export { getUserInfoServerAction } from 'next-flight-server-reference-proxy-loader?id=7faeb150b81200ad3bdff960aa5da3617f15401c67&name=getUserInfoServerAction!'